/*************************************************/
/* COOKIES                                       */
/*************************************************/

export function cookies() {
    const cookiePlaceholderSelector = '.cookie-placeholder';
    const placeholderSelectors = Array.from(document.querySelectorAll(cookiePlaceholderSelector));

    //Implement this for the specific cookie solution. Check out one of our other websites for an example
    const RenewConsent = categories => {
        alert("Implement functionality in 'cookies.js'");
    }

    const SetPlaceholderDisplayState = (placeholder,displayState) => {
        placeholder.css('display', displayState);
    }

    //Implement this for the specific cookie solution. Check out one of our other websites for an example. In this case, replace the 'false' with Cookie Consent status
    const SetPlaceholderState = () => {
        const marketingPlaceholders = document.querySelectorAll('[data-category="marketing"]');
        if (marketingPlaceholders != null) {
            marketingPlaceholders.forEach(placeholder => {
                let displayState = false ? 'none' : 'flex';
                SetPlaceholderDisplayState(placeholder,displayState);
            });
        }

        var statisticPlaceholders = document.querySelectorAll('[data-category="statistic"]');
        if (statisticPlaceholders != null) {
            statisticPlaceholders.forEach(placeholder => {
                var displayState = false ? 'none' : 'flex';
                SetPlaceholderDisplayState(placeholder,displayState);
            });
        }

        var statisticsPlaceholders = document.querySelectorAll('[data-category="statistics"]');
        if (statisticsPlaceholders != null) {
            statisticsPlaceholders.forEach(placeholder => {
                var displayState = false ? 'none' : 'flex';
                SetPlaceholderDisplayState(placeholder,displayState);
            });
        }

        var functionalPlaceholders = document.querySelectorAll('[data-category="functional"]');
        if (functionalPlaceholders != null) {
            functionalPlaceholders.forEach(placeholder => {
                var displayState = CookieInformation.getConsentGivenFor('cookie_cat_functional') ? 'none' : 'flex';
                SetPlaceholderDisplayState(placeholder,displayState);
            });
        }

        var preferencesPlaceholders = document.querySelectorAll('[data-category="preferences"]');
        if (preferencesPlaceholders != null) {
            preferencesPlaceholders.forEach(placeholder => {
                var displayState = CookieInformation.getConsentGivenFor('cookie_cat_functional') ? 'none' : 'flex';
                SetPlaceholderDisplayState(placeholder,displayState);
            });
        }
    }

    const init = () => {

        SetPlaceholderState();

        for(const placeholderSelector of placeholderSelectors) {
            placeholderSelector.addEventListener('click', event => {
                let placeholder = event.target;
                if(!placeholder.classList.contains(cookiePlaceholderSelector)) {
                    placeholder = event.target.closest(cookiePlaceholderSelector);
                }
                event.stopPropagation()
                var categories = placeholder.dataset.categories.split(',');
                RenewConsent(categories);
            });
        }
    };

    init();
}

